import type { MantineTheme } from '@mantine/core';
import type { TrustReconciliationByListingTableQueryRow } from './useTrustReconciliationByListingTableQuery';

const MAX_DEPTH = 2;

export const getTrustReconciliationByListingTableCellStyle = (
  theme: MantineTheme,
  {
    rowDepth,
    type,
  }: {
    rowDepth: number;
    type: TrustReconciliationByListingTableQueryRow['type'];
  }
) => {
  const depth = MAX_DEPTH - rowDepth;
  const bg = theme.colors.gray[depth];

  if (bg && type !== 'account') {
    return {
      backgroundColor: `${bg}!important`,
      fontWeight: 'bold',
    };
  }

  return {
    backgroundColor: `${theme.white}!important`,
    fontWeight: 'normal',
  };
};
